var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{directives:[{name:"title",rawName:"v-title",value:('Questionnaire'),expression:"'Questionnaire'"}],staticClass:"questionnaire"},[_vm._m(0),_c('router-view')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"page-title-bar"},[_c('div',{staticClass:"page-title"},[_vm._v(" How you doin'? ")])])
}]

export { render, staticRenderFns }